import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';

import { Item } from '../../menu';

import styles from '../../three-dots-menu.module.scss';
import './three-dots-menu-item-antd-overrides.css';
import { MenuInfo } from 'rc-menu/lib/interface';

type MenuItemProps = {
    onClick: (e: MenuInfo) => void;
    className?: string;
    disabled?: boolean;
    testId?: string;
};
export const ThreeDotsMenuItem = ({
    onClick,
    className,
    disabled = false,
    children,
    testId,
    ...rest
}: PropsWithChildren<MenuItemProps>) => {
    const itemClassNames = classNames(styles.menuItem, className, 'three-dots-menu-item', {
        [styles.disabled]: disabled,
        // passing the 'disabled' prop to Antd Item component
        // will ignore click events and propagate it to the menu container parent,
        // hence disabling it manually
    });

    return (
        <Item
            data-testid={testId}
            {...rest}
            onClick={(menuInfo) => {
                menuInfo.domEvent.stopPropagation();
                if (!disabled) {
                    onClick(menuInfo);
                }
            }}
            className={itemClassNames}
        >
            {children}
        </Item>
    );
};
